var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Modal } from "react-bootstrap";
var DescriptionModal = styled(Modal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .modal-content {\n    height: 370px;\n    position: relative;\n    top: 50px;\n    padding: ", ";\n  }\n"], ["\n  .modal-content {\n    height: 370px;\n    position: relative;\n    top: 50px;\n    padding: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.eight + " " + theme.spacing.four;
});
export default DescriptionModal;
var templateObject_1;
